module.exports = __webpack_public_path__ + "static/media/sunday.beec8f34.png";